import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import IndexPage from '../../components/pages/index/Index';
import Api from '../../helpers/api';
import Storage from '../../helpers/storage';
import Cart from '../../helpers/cart';
import { isBrowser } from '../../helpers/environment';
import { nextRedirect } from '../../helpers/navigation';

import {
  STORAGE_SETTINGS,
  STORAGE_NAVBAR,
  STORAGE_PRODUCTS,
  STORAGE_CONTACTS,
  SITE_INFO_CONTACTS,
  SITE_INFO_NAVBAR,
  SITE_INFO_SETTINGS,
  SITE_INFO_SLIDER,
} from '../../helpers/constants';

import {
  settingsProps, navbarProps, productProps, sliderProps, apiContactProps,
} from '../../helpers/propTypes';
import redirectDomain from '../../helpers/redirectDomain';
import { prepareCategoryTree } from '../../helpers/catalog';

function checkCategoryExist(res, catalog, categoryUrl) {
  const hasCategoryUrl = catalog.find((item) => item.slug === categoryUrl);

  if (!hasCategoryUrl) {
    nextRedirect('/404', res);
  }
}

function IndexPageWrapper(props) {
  const {
    navbar, products, settings, contacts,
  } = props;

  useEffect(() => {
    Storage.set(STORAGE_NAVBAR, navbar);
    Storage.set(STORAGE_PRODUCTS, products);
    Storage.set(STORAGE_SETTINGS, settings);
    Storage.set(STORAGE_CONTACTS, contacts);
    Cart.actualizeProducts(products);
  });

  return <IndexPage {...props} backUrl={`/category/${props.categoryUrl}`} />;
}

IndexPageWrapper.getInitialProps = async ({
  res, req, asPath, query,
}) => {
  const { categoryUrl } = query;
  const api = new Api({ domain: req ? req.headers.host : null });

  let products = null;
  let catalog = null;
  const cachedSiteInfo = {
    navbar: null,
    settings: null,
    contacts: null,
  };

  if (isBrowser()) {
    products = Storage.get(STORAGE_PRODUCTS);
    cachedSiteInfo.navbar = Storage.get(STORAGE_NAVBAR);
    cachedSiteInfo.settings = Storage.get(STORAGE_SETTINGS);
    cachedSiteInfo.contacts = Storage.get(STORAGE_CONTACTS);
  }

  products = products ?? await api.getProducts();

  const missingSiteInfoItems = [
    SITE_INFO_NAVBAR,
    SITE_INFO_SETTINGS,
    SITE_INFO_CONTACTS,
  ].filter((item) => !cachedSiteInfo[item]);
  const siteInfo = {
    ...cachedSiteInfo,
    ...(missingSiteInfoItems.length ? await api.getSiteInfo(missingSiteInfoItems) : {}),
  };

  catalog = prepareCategoryTree(products);
  checkCategoryExist(res, catalog, categoryUrl);

  if (!isBrowser()) {
    redirectDomain({
      settings: siteInfo.settings,
      host: req.headers.host,
      asPath,
      res,
    });
  }

  return {
    ...siteInfo,
    catalog,
    categoryUrl,
    products,
  };
};

IndexPageWrapper.PropTypes = {
  navbar: navbarProps.isRequired,
  slider: sliderProps,
  settings: settingsProps.isRequired,
  products: PropTypes.arrayOf(productProps).isRequired,
  catalog: PropTypes.array.isRequired,
  contacts: apiContactProps.isRequired,
};

export default IndexPageWrapper;
